import Hierarchy from './Hierarchy';

export default Hierarchy;
